const getOrderLineDosFrom2 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      const date = indexOrderLine['Date of Service From'] || indexOrderLine.dateOfServiceFrom;
      return date.replace(/[/]/g, '').substring(2, 4);
    }

    return null;
  }
  return orderLine
    ? orderLine.map((item) => {
      const date = item['Date of Service From'] || item.dateOfServiceFrom;
      return date.replace(/[/]/g, '').substring(2, 4);
    }).join(', ')
    : null;
};

export default getOrderLineDosFrom2;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDosFrom2.js